import { useRespondToAuthChallengeMutation } from 'apollo/queries/autogenerate/hooks-public';
import { fullWidthToHalfWidth } from 'shared/utils/japanese';

type Props = {
  code: string;
  sessionToken: string;
};

type ValidationResponse = {
  __typename: string;
  accessToken: string;
  idToken: string;
  refreshToken: string;
  session: string;
};

type AuthData = Omit<ValidationResponse, '__typename' | 'session'>;

const useValidatePin = () => {
  const [respondToAuthChallengeMutation] = useRespondToAuthChallengeMutation({
    context: {
      uri: process.env.CONSUMER_API_HOST_GRAPHQL_PUBLIC,
    },
  });

  const validatePin = (props: Props) => {
    return new Promise<AuthData>(async (resolve, reject) => {
      try {
        const result = await respondToAuthChallengeMutation({
          variables: {
            answer: fullWidthToHalfWidth(props.code),
            session: props.sessionToken,
          },
        });

        const {
          accessToken,
          idToken,
          refreshToken,
          session: sessionToken,
        } = result.data?.respondToAuthChallenge as ValidationResponse;

        if (sessionToken) {
          /**
           * If a sessionToken is returned, most probably the auth challenge has failed
           */
          reject({ sessionToken });
        } else {
          /**
           * If successful, accessToken, idToken, and refreshToken is returned
           */
          resolve({
            accessToken,
            idToken,
            refreshToken,
          });
        }
      } catch (err) {
        reject(err);
      }
    });
  };

  return validatePin;
};

export default useValidatePin;
export { AuthData };
